import { render, staticRenderFns } from "./ProductDetailsAvailability.vue?vue&type=template&id=4d8a0819&scoped=true"
import script from "./ProductDetailsAvailability.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsAvailability.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a0819",
  null
  
)

export default component.exports